import { http } from 'vue'

export default {
  // edit company_sku at the API server
  putCompanySku (context, params = {}) {
    return http.put('company_skus/' + params.id, params.data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/company_skus/actions.js